import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { nombreDepuisSaisie } from '../format/nombre';

export class CustomValidators {
  static noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isWhitespace = (control.value || '').trim().length === 0;
      return isWhitespace ? { noWhitespace: true } : null;
    };
  }

  /**
   * Equivalents de `Validators.min` / `Validators.max` pour les champs du kit.
   *
   * Ceux d'Angular font un `parseFloat`, qui s'arrete a la virgule : `1,50` y est lu
   * comme `1`, et `250,00` comme `250` — un maximum a 100 laisserait donc passer
   * `250,00` en le comparant a `250`, mais accepterait `99,99` en le lisant `99`.
   * Ces deux-ci normalisent la saisie avant de comparer.
   *
   * Ils rejettent aussi une saisie non numerique (`{ nombre: true }`), la ou Angular
   * la laisse passer : `parseFloat('abc')` rend `NaN`, et sa garde `!isNaN(value)`
   * conclut que la contrainte est respectee.
   *
   * @see nombreDepuisSaisie
   */
  static minNombre(min: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (estVide(control.value)) {
        return null;
      }

      const valeur = nombreDepuisSaisie(control.value);
      if (valeur === null) {
        return { nombre: true };
      }

      return valeur < min ? { min: { min, actual: valeur } } : null;
    };
  }

  static maxNombre(max: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (estVide(control.value)) {
        return null;
      }

      const valeur = nombreDepuisSaisie(control.value);
      if (valeur === null) {
        return { nombre: true };
      }

      return valeur > max ? { max: { max, actual: valeur } } : null;
    };
  }
}

/**
 * Meme convention que les validateurs d'Angular : un champ vide n'est pas invalide,
 * c'est a `Validators.required` de le dire. Sans cette garde, un formulaire
 * facultatif serait bloque tant que rien n'est saisi.
 */
function estVide(valeur: unknown): boolean {
  return valeur === null || valeur === undefined || (typeof valeur === 'string' && valeur.trim() === '');
}
